import i18n from '@/plugins/i18n'

// 获取翻译函数
const t = (key) => {
  return i18n.t(key)
}

// 根据产品ID获取对应翻译键
const getProductKey = (productId) => {
  const idKeyMap = {
    "CP-636456385274-sjz": "accessControlCardReader",
    "CP-636456385274-sz": "accessControlCardReaderFingerprint",
    "CP-636456385274-sj": "accessControlCardReaderKeypad",
    "CP-636456385274-s": "accessControlCardReaderSwipe",
    "CP-9894263426786": "wirelessElectronicLock",
    "CP-989897546892154": "pullLock",
    "CP-763542674424354": "faceRecognitionMachine",
    "CP-636546566494474": "accessController",
    "CP-9349464342694786": "miniatureElectronicLock",
    "CP-7446364826743786": "smartEjectionLock",
    "CP-269482642454786": "concealedMagneticLock",
    "CP-98269489464385274": "cylindricalCardReader",
    "CP-946744385274": "implicitCardReader",
    "CP-968548532157896": "allInOneCardReader",
    "CP-744636566494474": "tenDoorController",
    "CP-326636566494474": "singleDoorController",
    "CP-726636566494474": "threeDoorController",
    "CP-897546123547895": "sixDoorController",
    "CP-542436434269826": "integratedPowerSupply",
    "CP-524482634269826": "switchingPowerSupply",
    "CP-598746215874651": "contactFreeSwitch"
  }
  return idKeyMap[productId]
}

// 获取翻译后的产品特性
const getTranslatedFeatures = (productId, originalFeatures) => {
  const productKey = getProductKey(productId)
  if (!productKey) return originalFeatures

  const features = []
  for (let i = 0; i < originalFeatures.length; i++) {
    const translationKey = `products.productParam.products.${productKey}.features[${i}]`
    const translation = i18n.t(translationKey)
    // 如果翻译不存在，使用原始文本
    if (translation !== translationKey) {
      features.push(translation)
    } else {
      features.push(originalFeatures[i])
    }
  }
  return features
}

// 获取翻译后的参数名
const getTranslatedParamName = (name) => {
  const paramKeys = Object.keys(i18n.t('products.productParam.parameters'))
  for (const key of paramKeys) {
    if (i18n.t(`products.productParam.parameters.${key}`) === name) {
      return i18n.t(`products.productParam.parameters.${key}`)
    }
  }
  return name
}

// 获取翻译后的参数键
const getTranslatedParamKey = (key) => {
  const paramKeys = Object.keys(i18n.t('products.productParam.parameters'))
  for (const paramKey of paramKeys) {
    if (i18n.t(`products.productParam.parameters.${paramKey}`) === key) {
      return i18n.t(`products.productParam.parameters.${paramKey}`)
    }
  }
  return key
}

// 获取翻译后的产品参数项
const getTranslatedParamItems = (productId, originalItems) => {
  if (!originalItems || originalItems.length === 0) return []

  return originalItems.map(item => {
    const translatedName = getTranslatedParamName(item.name)
    const translatedParams = item.params.map(param => {
      return {
        key: getTranslatedParamKey(param.key),
        value: param.value
      }
    })

    return {
      name: translatedName,
      params: translatedParams
    }
  })
}

// 获取翻译后的产品名称
const getTranslatedProductName = (productId, originalName) => {
  const productKey = getProductKey(productId)
  if (!productKey) return originalName

  const translationKey = `products.productParam.products.${productKey}.name`
  const translation = i18n.t(translationKey)

  // 如果翻译不存在，使用原始文本
  if (translation !== translationKey) {
    return translation
  }
  return originalName
}

// 原始产品数据
const originalProducts = [
    {
        // 产品id
        id: "CP-636456385274-sjz",
        // 产品名
        productName: "门禁读卡器(刷卡/键盘/指纹)",
        // 产品图片
        catgImg: [
            // require("@/assets/img/product/product8.png"),
            require("@/assets/img/goods/entranceGuard/accsCtlCrdReader/accsCtlCrdReader2.png"),
            // require("@/assets/img/product/product8.png"),
            // require("@/assets/img/goods/entranceGuard/accsCtlCrdReader/accsCtlCrdReader2.png"),
            // require("@/assets/img/product/product8.png"),
            // require("@/assets/img/goods/entranceGuard/accsCtlCrdReader/accsCtlCrdReader2.png"),
            // require("@/assets/img/product/product8.png"),
        ],
        // 产品介绍
        productIntroduce: [
            "支持 13.56MHz 高频",
            "支持配置卡更改读卡器参数",
            "支持单指纹、卡 + 指纹模式",
            "电容触摸式键盘",
            "支持电源反接保护",
            "防拆保护（光敏电阻）",
            "输入和输入信号防静电保护",
            "支持面板定制化设计"
        ],
        // 参数
        productParamItem: [
            {
                name: '设备参数',
                params: [
                    {
                        key: '工作电压',
                        value: '7~17Vdc'
                    },
                    {
                        key: '读卡频率',
                        value: '125KHz、13.56MHz'
                    },
                    {
                        key: '读卡器配置',
                        value: i18n.t('products.productParam.parameters.values.duKaQiPeiZhi')
                    },
                    {
                        key: '标准输出',
                        value: i18n.t('products.productParam.parameters.values.weiGenShuChu')
                    },
                    {
                        key: '读卡器输出格式',
                        value: i18n.t('products.productParam.parameters.values.duKaQiShuChuGeShi')
                    },
                    {
                        key: '输入控制',
                        value:  i18n.t('products.productParam.parameters.values.shuRuKongZhi')
                    },
                    {
                        key: '韦根宽度',
                        value: i18n.t('products.productParam.parameters.values.weiGenKuanDu')
                    },
                    {
                        key: '键盘格式',
                        value: '4bits/8bits/26bits'
                    },
                    {
                        key: '读卡距离',
                        value: '125K：≥ 5cm'
                    },
                    {
                        key: '防水等级',
                        value: 'IP65'
                    },
                    {
                        key: '产品尺寸',
                        value: '116mm*85mm*18.5mm '
                    },
                    {
                        key: '外壳材质',
                        value: i18n.t('products.productParam.parameters.values.waiKeCaiZhi')
                    },
                    {
                        key: '产品颜色',
                        value: i18n.t('products.productParam.parameters.values.chanPinYanSe')
                    }
                ]
            },

            {
                name: '使用参数',
                params: [
                    {
                        key: '工作温度',
                        value: '-30℃ ~70℃'
                    },
                    {
                        key: '工作湿度',
                        value: i18n.t('products.productParam.parameters.values.gongZuoShiDu')
                    }
                ]
            }
        ],
    },
    {
        // 产品id
        id: "CP-636456385274-sz",
        // 产品名
        productName: "门禁读卡器(刷卡/指纹)",
        // 产品图片
        catgImg: [
            require("@/assets/img/goods/entranceGuard/accsCtlCrdReader/accsCtlCrdReader2.png"),
            // require("@/assets/img/goods/entranceGuard/accsCtlCrdReader/accsCtlCrdReader2.png"),
            // require("@/assets/img/goods/entranceGuard/accsCtlCrdReader/accsCtlCrdReader2.png"),
        ],
        // 产品介绍
        productIntroduce: [
            "支持 13.56MHz 高频",
            "支持配置卡更改读卡器参数",
            "支持单指纹、卡 + 指纹模式",
            "支持电源反接保护",
            "防拆保护（光敏电阻）",
            "输入和输入信号防静电保护",
            "支持面板定制化设计"
        ],
        // 参数
        productParamItem: [
            {
                name: '设备参数',
                params: [
                    {
                        key: '工作电压',
                        value: '7~17Vdc'
                    },
                    {
                        key: '读卡频率',
                        value: '125KHz、13.56MHz'
                    },
                    {
                        key: '读卡器配置',
                        value: i18n.t('products.productParam.parameters.values.duKaQiPeiZhi')
                    },
                    {
                        key: '标准输出',
                        value: i18n.t('products.productParam.parameters.values.weiGenShuChu')
                    },
                    {
                        key: '读卡器输出格式',
                        value: i18n.t('products.productParam.parameters.values.duKaQiShuChuGeShi')
                    },
                    {
                        key: '输入控制',
                        value: i18n.t('products.productParam.parameters.values.shuRuKongZhi')
                    },
                    {
                        key: '韦根宽度',
                        value: i18n.t('products.productParam.parameters.values.weiGenKuanDu')
                    },
                    {
                        key: '键盘格式',
                        value: '-'
                    },
                    {
                        key: '读卡距离',
                        value: '125K：≥ 5cm'
                    },
                    {
                        key: '防水等级',
                        value: 'IP65'
                    },
                    {
                        key: '产品尺寸',
                        value: '116mm*85mm*18.5mm '
                    },
                    {
                        key: '外壳材质',
                        value: i18n.t('products.productParam.parameters.values.waiKeCaiZhi')
                    },
                    {
                        key: '产品颜色',
                        value: i18n.t('products.productParam.parameters.values.chanPinYanSe')
                    }
                ]
            },

            {
                name: '使用参数',
                params: [
                    {
                        key: '工作温度',
                        value: '-30℃ ~70℃'
                    },
                    {
                        key: '工作湿度',
                        value: i18n.t('products.productParam.parameters.values.gongZuoShiDu')
                    }
                ]
            }
        ],
    },
    {
        // 产品id
        id: "CP-636456385274-sj",
        // 产品名
        productName: "门禁读卡器(刷卡/键盘)",
        // 产品图片
        catgImg: [
            // require("@/assets/img/goods/entranceGuard/accsCtlCrdReader/pinReader/accsCtlCrdReader3.png"),
            require("@/assets/img/goods/entranceGuard/accsCtlCrdReader/pinReader/密码读卡器.jpg"),
            require("@/assets/img/goods/entranceGuard/accsCtlCrdReader/pinReader/密码读卡器 (3).jpg"),
        ],
        // 产品介绍
        productIntroduce: [
            "支持 13.56MHz 高频",
            "支持配置卡更改读卡器参数",
            "电容触摸式键盘",
            "支持电源反接保护",
            "防拆保护（光敏电阻）",
            "输入和输入信号防静电保护",
            "支持面板定制化设计"
        ],
        // 参数
        productParamItem: [
            {
                name: '设备参数',
                params: [
                    {
                        key: '工作电压',
                        value: '7~17Vdc'
                    },
                    {
                        key: '读卡频率',
                        value: '125KHz、13.56MHz'
                    },
                    {
                        key: '读卡器配置',
                        value: i18n.t('products.productParam.parameters.values.duKaQiPeiZhi')
                    },
                    {
                        key: '标准输出',
                        value: i18n.t('products.productParam.parameters.values.weiGenShuChu')
                    },
                    {
                        key: '读卡器输出格式',
                        value: i18n.t('products.productParam.parameters.values.duKaQiShuChuGeShi')
                    },
                    {
                        key: '输入控制',
                        value:  i18n.t('products.productParam.parameters.values.shuRuKongZhi')
                    },
                    {
                        key: '韦根宽度',
                        value: i18n.t('products.productParam.parameters.values.weiGenKuanDu')
                    },
                    {
                        key: '键盘格式',
                        value: '4bits/8bits/26bits'
                    },
                    {
                        key: '读卡距离',
                        value: '125K：≥ 5cm'
                    },
                    {
                        key: '防水等级',
                        value: 'IP65'
                    },
                    {
                        key: '产品尺寸',
                        value: '116mm*85mm*18.5mm '
                    },
                    {
                        key: '外壳材质',
                        value: i18n.t('products.productParam.parameters.values.waiKeCaiZhi')
                    },
                    {
                        key: '产品颜色',
                        value: i18n.t('products.productParam.parameters.values.chanPinYanSe')
                    }
                ]
            },

            {
                name: '使用参数',
                params: [
                    {
                        key: '工作温度',
                        value: '-30℃ ~70℃'
                    },
                    {
                        key: '工作湿度',
                        value: i18n.t('products.productParam.parameters.values.gongZuoShiDu')
                    }
                ]
            }
        ],
    },
    {
        // 产品id
        id: "CP-636456385274-s",
        // 产品名
        productName: "门禁读卡器(刷卡)",
        // 产品图片
        catgImg: [
            // require("@/assets/img/goods/entranceGuard/accsCtlCrdReader/swipeCardReader/accsCtlCrdReader4.png"),
            require("@/assets/img/goods/entranceGuard/accsCtlCrdReader/swipeCardReader/刷卡读卡器.jpg"),
            require("@/assets/img/goods/entranceGuard/accsCtlCrdReader/swipeCardReader/刷卡读卡器 (3).jpg"),
        ],
        // 产品介绍
        productIntroduce: [
            "支持 13.56MHz 高频",
            "支持配置卡更改读卡器参数",
            "支持电源反接保护",
            "防拆保护（光敏电阻）",
            "输入和输入信号防静电保护",
            "支持面板定制化设计"
        ],
        // 参数
        productParamItem: [
            {
                name: '设备参数',
                params: [
                    {
                        key: '工作电压',
                        value: '7~17Vdc'
                    },
                    {
                        key: '读卡频率',
                        value: '125KHz、13.56MHz'
                    },
                    {
                        key: '读卡器配置',
                        value: i18n.t('products.productParam.parameters.values.duKaQiPeiZhi')
                    },
                    {
                        key: '标准输出',
                        value: i18n.t('products.productParam.parameters.values.weiGenShuChu')
                    },
                    {
                        key: '读卡器输出格式',
                        value: i18n.t('products.productParam.parameters.values.duKaQiShuChuGeShi')
                    },
                    {
                        key: '输入控制',
                        value:  i18n.t('products.productParam.parameters.values.shuRuKongZhi')
                    },
                    {
                        key: '韦根宽度',
                        value: i18n.t('products.productParam.parameters.values.weiGenKuanDu')
                    },
                    {
                        key: '键盘格式',
                        value: '-'
                    },
                    {
                        key: '读卡距离',
                        value: '125K：≥ 5cm'
                    },
                    {
                        key: '防水等级',
                        value: 'IP65'
                    },
                    {
                        key: '产品尺寸',
                        value: '116mm*85mm*18.5mm '
                    },
                    {
                        key: '外壳材质',
                        value: i18n.t('products.productParam.parameters.values.waiKeCaiZhi')
                    },
                    {
                        key: '产品颜色',
                        value: i18n.t('products.productParam.parameters.values.chanPinYanSe')
                    }
                ]
            },

            {
                name: '使用参数',
                params: [
                    {
                        key: '工作温度',
                        value: '-30℃ ~70℃'
                    },
                    {
                        key: '工作湿度',
                        value: i18n.t('products.productParam.parameters.values.gongZuoShiDu')
                    }
                ]
            }
        ],
    },
    {
        // 产品id
        id: "CP-9894263426786",
        // 产品名
        productName: "无线电锁",
        // 产品图片
        catgImg: [
            require("@/assets/img/goods/entranceGuard/electronicLk/electronicLk1.png"),
            // require("@/assets/img/goods/entranceGuard/electronicLk/electronicLk1.png"),
            // require("@/assets/img/goods/entranceGuard/electronicLk/electronicLk1.png"),
        ],
        // 产品介绍
        productIntroduce: [
            "智能，安全，创新和安装简单",
            "电子门锁无需布线，为您提供功能丰富的无布线网络化电子门锁解决方案",
            "可左右换向把手电子锁",
            "离合式电子锁，解锁之后把手可自由转动",
            "与欧标锁芯和瑞士标锁芯兼容",
            "任何类型的门都可进行简便的安装",
            "锁体和电子把手采用钢制结构",
            "可提供机械锁芯开孔，用于机械钥匙解锁或上锁 , 可通过审计追踪查询",
            "门锁始终可以从室内开启（选择相应的插芯锁体，只需压把手这一简单操作，即可实现紧急情况下逃生）"
        ],
        // 参数
        productParamItem: [
            {
                name: '设备参数',
                params: [
                    {
                        key: '适用门厚度',
                        value: i18n.t('products.productParam.parameters.values.shaTouMenHouDu')
                    },
                    {
                        key: '尺寸',
                        value: '282mm x 40mm x 20mm'
                    },
                    {
                        key: '把手转动角度',
                        value: '33°'
                    },
                    {
                        key: '把手至锁芯的距离',
                        value: i18n.t('products.productParam.parameters.values.shaTouSuoXinDaoBaShou')
                    }
                ]
            },
        ],
    },
    {
        // 产品id
        id: "CP-989897546892154",
        // 产品名
        productName: "拉手锁",
        // 产品图片
        catgImg: [
            require("@/assets/img/goods/entranceGuard/electronicLk/pullLocks/拉手锁1.jpg"),
            require("@/assets/img/goods/entranceGuard/electronicLk/pullLocks/拉手锁2.jpg"),
            require("@/assets/img/goods/entranceGuard/electronicLk/pullLocks/拉手锁3.jpg"),
        ],
        // 产品介绍
        productIntroduce: [
            "手机远程开锁",
            "独有安全网关，保障信息安全",
            "电源反接保护",
            "一体化设计，操作便捷",
            "支持NFC、刷卡模式",
            "防拆保护（光敏电阻）",
            "输入和输入信号防静电保护",
            "支持13.56MHz高频"
        ],
        // 参数
        productParamItem: [
            {
                name: '设备参数',
                params: [
                    {
                        key: '读卡频率',
                        value: '125KHz、13.56MHz'
                    },
                    {
                        key: '标准输出',
                        value: i18n.t('products.productParam.parameters.values.weiGenShuChu')
                    },
                    {
                        key: '读卡器输出格式：',
                        value: i18n.t('products.productParam.parameters.values.duKaQiShuChuGeShi')
                    },
                    {
                        key: '输入控制',
                        value: i18n.t('products.productParam.parameters.values.shuRuKongZhi')
                    },
                    {
                        key: '韦根宽度',
                        value: i18n.t('products.productParam.parameters.values.weiGenKuanDu')
                    },
                    {
                        key: '读卡距离',
                        value: '125K：≥5cm;13.56MHz :5~10cm'
                    },
                    {
                        key: '防水等级',
                        value: 'IP65'
                    },
                    {
                        key: '外壳材质',
                        value: i18n.t('products.productParam.parameters.values.waiKeCaiZhiJinShu')
                    }
                ]
            },
            {
                name: '使用参数',
                params: [
                    {
                        key: '工作电压',
                        value: '3~6Vdc'
                    },
                    {
                        key: '工作温度',
                        value: '-30℃~70℃'
                    },
                    {
                        key: '工作湿度',
                        value: i18n.t('products.productParam.parameters.values.gongZuoShiDu')
                    },
                    {
                        key: '把手至锁芯的距离',
                        value: i18n.t('products.productParam.parameters.values.shaTouSuoXinDaoBaShou')
                    }
                ]
            }
        ],
    },
    {
        // 产品id
        id: "CP-763542674424354",
        // 产品名
        productName: "人脸识别机",
        // 产品图片
        catgImg: [
            // require("@/assets/img/goods/entranceGuard/humanFaceRecognitionMachine/faceMachine/人脸识别一体机.png"),
            // require("@/assets/img/goods/entranceGuard/humanFaceRecognitionMachine/humanFaceRecognitionMachine1.png"),
            require("@/assets/img/goods/entranceGuard/humanFaceRecognitionMachine/faceMachine/人脸机 (2).jpg"),
            require("@/assets/img/goods/entranceGuard/humanFaceRecognitionMachine/faceMachine/人脸机 (4).jpg"),

        ],
        // 产品介绍
        productIntroduce: [
            "防窃取攻击",
            "活体检测",
            "支持传输机",
            "信息加密",
        ],
        // 参数
        productParamItem: [
            {
                name: '设备参数',
                params: [
                    {
                        key: '操作系统',
                        value: 'Android8.1'
                    },
                    {
                        key: '人脸识别',
                        value: i18n.t('products.productParam.parameters.values.renLianShiBie')
                    },
                    {
                        key: '主要芯片规格',
                        value: 'CPU: 8Cortex-A53 at 2.0GHz/GPU: Adreno 506@650MHz2GB DDR3'
                    },
                    {
                        key: '内 存',
                        value: '16GB'
                    },
                    {
                        key: 'WiFi 蓝牙模块',
                        value: 'IEEE802.11a/b/g/n,IEEE802.11ac'
                    },
                    {
                        key: '设备尺寸 ( 长宽高 )',
                        value: i18n.t('products.productParam.parameters.values.sheBeiChiCun')
                    },
                    {
                        key: '摄像头模组 ( 双目 )',
                        value: i18n.t('products.productParam.parameters.values.sheXiangTouMoZu')
                    },
                    {
                        key: '补光灯',
                        value: i18n.t('products.productParam.parameters.values.buGuangDeng')
                    },
                    {
                        key: '显示屏',
                        value: 'LCD'
                    },
                    {
                        key: '屏幕比例 -- 分辨率',
                        value: '16:9 -- 720*1280/8001280'
                    },
                    {
                        key: '设备电源',
                        value: '12VDC 土 10%.2A'
                    },
                    {
                        key: '设备功率',
                        value: '10W'
                    }
                ]
            },

            {
                name: '使用参数',
                params: [
                    {
                        key: '工作温度',
                        value: '-30~75C'
                    },
                    {
                        key: '工作湿度',
                        value: i18n.t('products.productParam.parameters.values.gongZuoShiDuBuJingJieShuiDi')
                    },
                ]
            },
        ],
    },
    {
        // 产品id
        id: "CP-636546566494474",
        // 产品名
        productName: "门禁控制器",
        // 产品图片
        catgImg: [
            // require("@/assets/img/goods/entranceGuard/Controller/accessController/门禁控制器.png"),
            // require("@/assets/img/goods/entranceGuard/Controller/accessController/门禁控制器开盖.png"),
            require("@/assets/img/goods/entranceGuard/Controller/accessController/门禁控制器 (1).jpg"),
            require("@/assets/img/goods/entranceGuard/Controller/accessController/门禁控制器 (6).jpg"),
            require("@/assets/img/goods/entranceGuard/Controller/accessController/门禁控制器 (5).jpg"),

        ],
        // 产品介绍
        productIntroduce: [
            "RS485 和 Wiegand 双通讯接口可接入包括人脸识别、读卡器、指纹、人脸加卡片双重验证等读头。",
        ],
        // 参数
        productParamItem: [
            {
                name: '设备参数',
                params: [
                    {
                        key: '工作电压',
                        value: i18n.t('products.productParam.parameters.values.gongZuoDianYa12V')
                    },
                    {
                        key: '处理器',
                        value: i18n.t('products.productParam.parameters.values.chuLiQi32')
                    },
                    {
                        key: '储存容量',
                        value: i18n.t('products.productParam.parameters.values.cunChuRongLiang')
                    },
                    {
                        key: '工作电流',
                        value: '150mA'
                    },
                    {
                        key: '报警输出',
                        value: i18n.t('products.productParam.parameters.values.baoJingShuChu')
                    },
                    {
                        key: '电锁继电器',
                        value: i18n.t('products.productParam.parameters.values.baoJingShuChu')
                    },
                    {
                        key: '尺寸',
                        value: '159.5*110 mm'
                    }
                ]
            },

            {
                name: '使用参数',
                params: [
                    {
                        key: '工作温度',
                        value: '-10℃ -60℃'
                    },
                ]
            },
        ],
    },
    {
        // 产品id
        id: "CP-9349464342694786",
        // 产品名
        productName: "微型电子锁",
        // 产品图片
        catgImg: [
            require("@/assets/img/goods/displayCase/electronicLk/miniatureElectronicLocks/微型电子锁 (1).jpg"),
            require("@/assets/img/goods/displayCase/electronicLk/miniatureElectronicLocks/微型电子锁 (5).jpg"),
        ],
        // 产品介绍
        productIntroduce: [
            "原创发明、设计生产，产品质量稳定可靠",
            "采用铸造工艺一次成型、耐磨损、耐腐蚀",
            "机械结构和电子控制系统完美结合",
            "全新的防撬功能设计",
            "锁体颜色可定制"
        ],
        // 参数
        productParamItem: [
            {
                name: '设备参数',
                params: [
                    {
                        key: '工作电压',
                        value: 'DC12V ±10%'
                    },
                    {
                        key: '工作电流',
                        value: '0.3A'
                    },
                    {
                        key: '可承受里力',
                        value: '250KG'
                    },
                    {
                        key: '开锁方式',
                        value: i18n.t('products.productParam.parameters.values.kaiSuoFangShi')
                    },
                    {
                        key: '锁体尺寸',
                        value: 'L109mm*W18mm*H23mm'
                    },
                    {
                        key: '锁扣板尺寸',
                        value: 'L57mm*W18mm*H1.3mm'
                    }
                ]
            },

            {
                name: '使用参数',
                params: [
                    {
                        key: '工作温度',
                        value: '-10℃ - 60℃'
                    },
                ]
            },
        ],
    },
    {
        // 产品id
        id: "CP-7446364826743786",
        // 产品名
        productName: "智能弹射锁",
        // 产品图片
        catgImg: [
            require("@/assets/img/goods/displayCase/electronicLk/弹力锁.png"),
            // require("@/assets/img/goods/displayCase/electronicLk/electronicLk_zntss.png"),
            // require("@/assets/img/goods/displayCase/electronicLk/electronicLk_zntss.png"),
        ],
        // 产品介绍
        productIntroduce: [
            "通电弹开 / 断电手动关门上锁",
            "上锁闭合 / 开锁断开",
        ],
        // 参数
        productParamItem: [
            {
                name: '设备参数',
                params: [
                    {
                        key: '电气参数',
                        value: 'DC12V/2A（DC24V/1A）'
                    },
                    {
                        key: '工作方式',
                        value: i18n.t('products.productParam.parameters.values.gongZuoFangShi')
                    },
                    {
                        key: '反馈信号',
                        value: i18n.t('products.productParam.parameters.values.fanKuiXinHao')
                    },
                    {
                        key: '开门弹力',
                        value: '<5KG'
                    },
                    {
                        key: '产品尺寸',
                        value: '73*66*13MM'
                    }
                ]
            },

        ],
    },
    {
        // 产品id
        id: "CP-269482642454786",
        // 产品名
        productName: "暗装磁力锁",
        // 产品图片
        catgImg: [
            require("@/assets/img/goods/displayCase/electronicLk/electronicLk_azcls.png"),
            // require("@/assets/img/goods/displayCase/electronicLk/electronicLk_azcls.png"),
            // require("@/assets/img/goods/displayCase/electronicLk/electronicLk_azcls.png"),
        ],
        // 产品介绍
        productIntroduce: [
            "铝合金外壳",
            "内置反向突破保护功能",
            "适用范围：抽屉、移门、柜门等"
        ],
        // 参数
        productParamItem: [
            // 项
            {
                name: '设备参数',
                params: [
                    {
                        key: '工作电压',
                        value: '12v/24v'
                    },
                    {
                        key: '工作电流',
                        value: '140MA/240MA'
                    },
                    {
                        key: '锁体尺寸',
                        value: '135x35x20(mm)'
                    },
                    {
                        key: '吸板尺寸',
                        value: '76x34x11(mm)'
                    },
                    {
                        key: '承受拉力',
                        value: '60KG'
                    }
                ]
            },

        ],
    },
    {
        // 产品id
        id: "CP-98269489464385274",
        // 产品名
        productName: "圆柱形读卡器(明装)",
        // 产品图片
        catgImg: [
            // require("@/assets/img/goods/displayCase/crdReader/crdReader_mz.png"),
            require("@/assets/img/goods/displayCase/crdReader/cylindricalCardReader/圆柱形读卡器 (1).jpg"),
            require("@/assets/img/goods/displayCase/crdReader/cylindricalCardReader/圆柱形读卡器 (2).jpg"),
            require("@/assets/img/goods/displayCase/crdReader/cylindricalCardReader/圆柱形读卡器 (4).jpg"),
            require("@/assets/img/goods/displayCase/crdReader/cylindricalCardReader/圆柱形读卡器 (8).jpg"),
        ],
        // 产品介绍
        productIntroduce: [
            "支持 HID Prox 兼容卡，ISO14443A，ISO15693 等卡片技术（可选择不同的卡片技术）",
            "内嵌红绿双色 LED 背光指示灯显示储物柜状态",
            "背部螺纹卡口两种设计"
        ],
        // 参数
        productParamItem: [
            // 项
            {
                name: '设备参数',
                params: [
                    {
                        key: '工作电压',
                        value: '7~28Vdc'
                    },
                    {
                        key: '防水等级',
                        value: 'IP65'
                    },
                    {
                        key: '外壳材质',
                        value: i18n.t('products.productParam.parameters.values.waiKeCaiZhiABSandPc')
                    },
                    {
                        key: '产品颜色',
                        value: i18n.t('products.productParam.parameters.values.dingZhiYanSe')
                    },
                    {
                        key: '产品尺寸',
                        value: '22*22*18.5mm'
                    }
                ]
            },
            {
                name: '使用参数',
                params: [
                    {
                        key: '工作温度',
                        value: '-20℃ ~60℃'
                    },
                    {
                        key: '工作湿度',
                        value: i18n.t('products.productParam.parameters.values.gongZuoShiDu')
                    },
                ]
            },

        ],
    },
    {
        // 产品id
        id: "CP-946744385274",
        // 产品名
        productName: "读卡器(隐式安装)",
        // 产品图片
        catgImg: [
            require("@/assets/img/goods/displayCase/crdReader/implicitCardReader/隐式安装读卡器 (1).jpg"),
            require("@/assets/img/goods/displayCase/crdReader/implicitCardReader/隐式安装读卡器 (5).jpg"),
        ],
        // 产品介绍
        productIntroduce: [
            "智能芯片",
            "室外防水设计",
            "良好的抗金属干扰",
            "可隐藏式安装"
        ],
        // 参数
        productParamItem: [
            // 项
            {
                name: '设备参数',
                params: [
                    {
                        key: '工作电压',
                        value: '7~28Vdc'
                    },
                    {
                        key: '防水等级',
                        value: 'IP65'
                    },
                    {
                        key: '外壳材质',
                        value: i18n.t('products.productParam.parameters.values.waiKeCaiZhiABSandPc')
                    },
                    {
                        key: '产品颜色',
                        value: i18n.t('products.productParam.parameters.values.dingZhiYanSe')
                    },
                    {
                        key: '产品尺寸',
                        value: '50*30*10（7） mm'
                    }
                ]
            },
            {
                name: '使用参数',
                params: [
                    {
                        key: '工作温度',
                        value: '-20℃ ~60℃'
                    },
                    {
                        key: '工作湿度',
                        value: i18n.t('products.productParam.parameters.values.gongZuoShiDu')
                    },
                ]
            },

        ],
    },
    {
        // 产品id
        id: "CP-968548532157896",
        // 产品名
        productName: "读卡器一体机",
        // 产品图片
        catgImg: [
            require("@/assets/img/goods/displayCase/crdReader/allInOneCardReader/读卡器一体机斜面.png"),
            require("@/assets/img/goods/displayCase/crdReader/allInOneCardReader/读卡器一体机侧面.png"),
            require("@/assets/img/goods/displayCase/crdReader/allInOneCardReader/读卡一体机 (5).jpg"),
        ],
        // 产品介绍
        productIntroduce: [
            "小巧简约",
            "嵌入式安装",
            "表面安装",
            "支持1024个用户"
        ],
        // 参数
        productParamItem: [
            // 项
            {
                name: '设备参数',
                params: [
                    {
                        key: '防水等级',
                        value: 'IP65'
                    },
                    {
                        key: '产品尺寸',
                        value: 'L78mm*W32mm*H14mm'
                    },
                    {
                        key: '外壳材质',
                        value: i18n.t('products.productParam.parameters.values.waiKeCaiZhiABSandPc')
                    },
                    {
                        key: '产品颜色',
                        value: i18n.t('products.productParam.parameters.values.tanHuiSe')
                    },
                    {
                        key: '安装方式',
                        value: i18n.t('products.productParam.parameters.values.biaoMianHuoQianRu')
                    }
                ]
            },
            {
                name: '使用参数',
                params: [
                    {
                        key: '工作电压',
                        value: ' 7~28Vdc'
                    },
                    {
                        key: '工作温度',
                        value: '-20℃~60℃'
                    },
                    {
                        key: '工作湿度',
                        value: i18n.t('products.productParam.parameters.values.gongZuoShiDu')
                    },
                ]
            },

        ],
    },
    {
        // 产品id
        id: "CP-744636566494474",
        // 产品名
        productName: "储物柜专用十门控制器",
        // 产品图片
        catgImg: [
            require("@/assets/img/goods/displayCase/controller/tenDoorControllers/十门控制器.png"),
            // require("@/assets/img/goods/displayCase/controller/tenDoorControllers/十门控制器 (1).jpg"),
            require("@/assets/img/goods/displayCase/controller/tenDoorControllers/十门控制器 (2).jpg"),
            // require("@/assets/img/goods/displayCase/controller/controller-shimen.png"),
            // require("@/assets/img/goods/displayCase/controller/controller-shimen.png"),
        ],
        // 产品介绍
        productIntroduce: [
            "支持有电锁，无电锁",
            "支持门磁输入",
            "支持红色，绿色指示灯反馈"
        ],
        // 参数
        productParamItem: [
            // 项
            {
                name: '设备参数',
                params: [
                    {
                        key: '工作电压',
                        value: '7~16VDC'
                    },
                    {
                        key: '工作电流',
                        value: '100ma@12VDC'
                    },
                    {
                        key: '通讯接口',
                        value: i18n.t('products.productParam.parameters.values.TCPTongXun')
                    },
                    {
                        key: '电锁接口',
                        value: i18n.t('products.productParam.parameters.values.dianSuoJieKou')
                    },
                    {
                        key: '读卡器接口',
                        value: i18n.t('products.productParam.parameters.values.duKaQiJieKou')
                    }
                ]
            }

        ],
    },
    {
        // 产品id
        id: "CP-326636566494474",
        // 产品名
        productName: "单门控制器",
        // 产品图片
        catgImg: [
            require("@/assets/img/goods/displayCase/controller/controller-danmen.png"),
            // require("@/assets/img/goods/displayCase/controller/controller-danmen.png"),
            // require("@/assets/img/goods/displayCase/controller/controller-danmen.png"),
        ],
        // 产品介绍
        productIntroduce: [
            "1 万持卡人，5 万 -10 万条离线事件",
            "支持关门延时时间设置",
            "表面安装",
            "TCP/IP 网络通信",
            "无线 WIFI 连接",
            "标准维根读卡器接口，电锁接口，门磁接口"
        ],
        // 参数
        productParamItem: [],
    },
    {
        // 产品id
        id: "CP-726636566494474",
        // 产品名
        productName: "三门控制器",
        // 产品图片
        catgImg: [
            // require("@/assets/img/goods/displayCase/controller/threeDoorController/controller-sanmen.png"),
            require("@/assets/img/goods/displayCase/controller/threeDoorController/三门控制器 (1).jpg"),
            require("@/assets/img/goods/displayCase/controller/threeDoorController/三门控制器 (5).jpg"),
            require("@/assets/img/goods/displayCase/controller/threeDoorController/三门控制器 (9).jpg"),
        ],
        // 产品介绍
        productIntroduce: [
            "1 万持卡人，5 万 -10 万条离线事件",
            "支持关门延时时间设置",
            "表面安装",
            "TCP/IP 网络通信",
            "无线 WIFI 连接",
            "标准维根读卡器接口，电锁接口，门磁接口"
        ],
        // 参数
        productParamItem: [],
    },
    {
        // 产品id
        id: "CP-897546123547895",
        // 产品名
        productName: "六门控制器",
        // 产品图片
        catgImg: [
            require("@/assets/img/goods/displayCase/controller/sixDoorController/六门控制器 (4).jpg"),
            require("@/assets/img/goods/displayCase/controller/sixDoorController/六门控制器 (5).jpg"),
            require("@/assets/img/goods/displayCase/controller/sixDoorController/六门控制器 (6).jpg"),
        ],
        // 产品介绍
        productIntroduce: [
            "1 万持卡人，5 万 -10 万条离线事件",
            "支持关门延时时间设置",
            "表面安装",
            "TCP/IP 网络通信",
            "无线 WIFI 连接",
            "标准维根读卡器接口，电锁接口，门磁接口"
        ],
        // 参数
        productParamItem: [],
    },
    {
        // 产品id
        id: "CP-542436434269826",
        // 产品名
        productName: "专用集成电源",
        // 产品图片
        catgImg: [
            require("@/assets/img/goods/displayCase/powerSupply/integratedPowerSupply/专用集成电源 (2).jpg"),
            require("@/assets/img/goods/displayCase/powerSupply/integratedPowerSupply/专用集成电源 (1).jpg"),
            // require("@/assets/img/goods/displayCase/powerSupply/powerSupply_jicheng.png"),
        ],
        // 产品介绍
        productIntroduce: [
            "储物格以及桌面方便安装",
            "前面板配置LED 电源指示灯",
            "内置过 CQC 认证工业级模块电源，具有短路保护、过流保护，过载保护",
            "输入带有短路保险管保护",
            "输出每路带独立指示灯，具有短路保护、过流保护，过载保护，每路接线端子可以插拔，便于安装和维护；",
            "标准维根读卡器接口，电锁接口，门磁接口",
            "具备可靠的防雷接地保护"
        ],
        // 参数
        productParamItem: [
            // 项
            {
                name: '设备参数',
                params: [
                    {
                        key: '最大输出功率',
                        value: '200w'
                    },
                    {
                        key: '输出电压',
                        value: '12V'
                    },
                    {
                        key: '最大输出电流',
                        value: '17A'
                    },
                    {
                        key: '单路输出电流',
                        value: i18n.t('products.productParam.parameters.values.danLuShuChu')
                    },
                    {
                        key: '产品尺寸',
                        value: i18n.t('products.productParam.parameters.values.chiCun1')
                    }
                ]
            },

        ],
    },
    {
        // 产品id
        id: "CP-524482634269826",
        // 产品名
        productName: "开关电源",
        // 产品图片
        catgImg: [
            require("@/assets/img/goods/displayCase/powerSupply/powerSupply_kaiguan.png"),
            // require("@/assets/img/goods/displayCase/powerSupply/powerSupply_kaiguan.png"),
            // require("@/assets/img/goods/displayCase/powerSupply/powerSupply_kaiguan.png"),
        ],
        // 产品介绍
        productIntroduce: [
            "设备机身由金属材质制作，电源底盖，采用铝合金材质",
            "电源上盖外观采用六边形窝蜂孔贯穿盖体，便于设备的散热",
            "预留从底部安装以及正面安装的孔位，以便于不同场景进行安装固定",
        ],
        // 参数
        productParamItem: [
            // 项
            {
                name: '设备参数',
                params: [
                    {
                        key: '输入电压',
                        value: '176~264VAC'
                    },
                    {
                        key: '最大输入电流',
                        value: '0.8A'
                    },
                    {
                        key: '待机功耗',
                        value: '< 0.3W@230VAC'
                    },
                    {
                        key: '输出电压',
                        value: '12VDC'
                    },
                    {
                        key: '输出总电流',
                        value: '4.2A'
                    },
                    {
                        key: '输出保护',
                        value: i18n.t('products.productParam.parameters.values.shuChuBaoHu')
                    },
                    {
                        key: '产品尺寸',
                        value: '99 x 82 x 30 mm'
                    },
                    {
                        key: '外观材质',
                        value: '金属外壳'
                    },
                ]
            },
            // 项
            {
                name: '使用参数',
                params: [
                    {
                        key: '工作温度',
                        value: '- 30℃ to +70℃'
                    },
                    {
                        key: '工作湿度',
                        value: i18n.t('products.productParam.parameters.values.shiDuWuLengJing')
                    },
                ]
            },

        ],
    },
    {
        // 产品id
        id: "CP-598746215874651",
        // 产品名
        productName: "免接触开门按钮",
        // 产品图片
        catgImg: [
            require("@/assets/img/goods/entranceGuard/contactFreeSwitch/switchButtons/开门按钮 (1).jpg"),
            require("@/assets/img/goods/entranceGuard/contactFreeSwitch/switchButtons/开门按钮 (13).jpg"),
            require("@/assets/img/goods/entranceGuard/contactFreeSwitch/switchButtons/开门按钮 (6).jpg"),
        ],
        // 产品介绍
        productIntroduce: [
            "非接触式",
            "采用非接触电容式感应技术",
        ],
        // 参数
        productParamItem: [
            {
                name: '设备参数',
                params: [
                    {
                        key: '报警声音',
                        value: i18n.t('products.productParam.parameters.values.fengMingQi')
                    },
                    {
                        key: '通讯协议',
                        value: i18n.t('products.productParam.parameters.values.weiGenShuChu')
                    },
                    {
                        key: '指示灯',
                        value: i18n.t('products.productParam.parameters.values.dianYuanZhiShiDeng')
                    },
                    {
                        key: '产品尺寸',
                        value: '86mm*86mm '
                    },
                    {
                        key: '产品颜色',
                        value: i18n.t('products.productParam.parameters.values.heiBai')
                    },
                    {
                        key: '结构',
                        value: i18n.t('products.productParam.parameters.values.suLiaoMianBan')
                    },
                    {
                        key: '防护等级',
                        value: 'IP64'
                    },
                    {
                        key: '安装方式',
                        value: i18n.t('products.productParam.parameters.values.qianRuShi86DianHe')
                    }
                ]
            },

            {
                name: '使用参数',
                params: [
                    {
                        key: '读取距离',
                        value: '1≥5cm'
                    },
                    {
                        key: '工作电压',
                        value: '7~28Vdc'
                    },
                    {
                        key: '工作温度',
                        value: '-30℃~70℃'
                    },
                    {
                        key: '工作温度',
                        value: i18n.t('products.productParam.parameters.values.gongZuoShiDu')
                    },
                ]
            },
        ],
    },

]

// 生成带有翻译的产品数据
const getProduct = () => {
  return originalProducts.map(product => {
    return {
      id: product.id,
      productName: getTranslatedProductName(product.id, product.productName),
      catgImg: product.catgImg,
      productIntroduce: getTranslatedFeatures(product.id, product.productIntroduce),
      productParamItem: getTranslatedParamItems(product.id, product.productParamItem)
    }
  })
}

// 导出带翻译功能的产品数据
export const product = getProduct()
